module.exports = __webpack_public_path__ + "kudos_10.svg?ce112757865ac16223648ff6a64441bf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kudos/kudos_10.svg
// module id = 107
// module chunks = 0